import { render, staticRenderFns } from "./RequestEditTabApprovals.vue?vue&type=template&id=4b08238e&scoped=true&"
import script from "./RequestEditTabApprovals.vue?vue&type=script&lang=js&"
export * from "./RequestEditTabApprovals.vue?vue&type=script&lang=js&"
import style0 from "./RequestEditTabApprovals.vue?vue&type=style&index=0&id=4b08238e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b08238e",
  null
  
)

export default component.exports